import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const springEasing = [0.22, 1, 0.36, 1];

const testimonials = [
{
  id: 1,
  name: 'Erik Haugen',
  title: 'Daglig leder, NorTrans AS',
  photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b24a2a2a-1772199582149.png",
  photoAlt: 'Erik Haugen, middle-aged Norwegian man with short brown hair and glasses, wearing a dark business suit',
  quote: 'Veiassistent har revolusjonert måten vi håndterer bomkostnader på. Vi sparer over 180 000 kr i året bare på ruteoptimalisering. Systemet er intuitivt og teamet er alltid tilgjengelig for support.',
  company: 'NorTrans AS',
  savings: '180 000 kr/år',
  rating: 5
},
{
  id: 2,
  name: 'Ingrid Solberg',
  title: 'Flåtesjef, Bergen Buss',
  photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1de9d6bd5-1772127504385.png",
  photoAlt: 'Ingrid Solberg, professional Norwegian woman with blonde hair, wearing a navy blazer and confident smile',
  quote: 'Med 45 busser i flåten var bomkostnadene en enorm utgiftspost. Veiassistent ga oss full oversikt og vi reduserte kostnadene med 38% på bare tre måneder. Imponerende resultat!',
  company: 'Bergen Buss',
  savings: '320 000 kr/år',
  rating: 5
},
{
  id: 3,
  name: 'Lars Kristiansen',
  title: 'Transportsjef, Fjord Frakt',
  photo: "https://img.rocket.new/generatedImages/rocket_gen_img_169ea52a7-1772199583077.png",
  photoAlt: 'Lars Kristiansen, tall Norwegian man with dark hair and beard, wearing a casual business shirt outdoors',
  quote: 'Rapporteringsfunksjonen alene er verdt prisen. Vi kan nå dokumentere alle bomkostnader per oppdrag og fakturere kunder nøyaktig. Det har eliminert diskusjoner om kostnader fullstendig.',
  company: 'Fjord Frakt',
  savings: '95 000 kr/år',
  rating: 5
},
{
  id: 4,
  name: 'Marte Andersen',
  title: 'CEO, Stavanger Taxi',
  photo: "https://img.rocket.new/generatedImages/rocket_gen_img_105ac9905-1772199582902.png",
  photoAlt: 'Marte Andersen, professional Norwegian woman with dark hair, wearing a red blazer and warm smile in office setting',
  quote: 'Som taxiselskap med 120 biler er bomkostnader kritisk for lønnsomheten. Veiassistent hjelper sjåførene våre å velge de billigste rutene i sanntid. Sjåførene elsker det!',
  company: 'Stavanger Taxi',
  savings: '240 000 kr/år',
  rating: 5
}];


const StarRating = ({ count }) =>
<div style={{ display: 'flex', gap: '3px' }}>
    {Array.from({ length: count })?.map((_, i) =>
  <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#FF5722" stroke="none">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
  )}
  </div>;


const TestimonialsSection = () => {
  const [active, setActive] = useState(0);
  const current = testimonials?.[active];

  return (
    <section style={{ padding: '80px 24px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: '56px', display: 'flex', alignItems: 'flex-start', gap: '24px' }}>
        <div style={{ flexShrink: 0, marginTop: '6px' }}>
          <div style={{ width: '3px', height: '48px', background: '#FF5722', borderRadius: '2px' }} />
        </div>
        <div>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF5722', display: 'block', marginBottom: '8px' }}>Kundehistorier</span>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '36px', fontWeight: 700, color: 'var(--color-foreground)', marginBottom: '12px', letterSpacing: '-0.02em' }}>Hva kundene sier</h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', color: 'var(--color-muted-foreground)', maxWidth: '520px', lineHeight: 1.6 }}>Ekte tilbakemeldinger fra norske bedrifter som har transformert sin bompengehåndtering med Veiassistent.</p>
        </div>
      </div>
      {/* Main testimonial card */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', marginBottom: '32px' }}>
        {/* Featured testimonial */}
        <AnimatePresence mode="wait">
          <motion.div
            key={current?.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.4, ease: springEasing }}
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(224,228,232,0.1)',
              borderRadius: '2px',
              padding: '40px',
              position: 'relative',
              overflow: 'hidden',
              gridColumn: '1 / -1'
            }}>
            
            {/* Beveled corner accent */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: '0', height: '0', borderTop: '40px solid rgba(255,87,34,0.15)', borderRight: '40px solid transparent' }} />
            <div style={{ position: 'absolute', bottom: 0, right: 0, width: '0', height: '0', borderBottom: '40px solid rgba(0,79,152,0.1)', borderLeft: '40px solid transparent' }} />

            <div style={{ display: 'flex', gap: '32px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
              {/* Photo */}
              <div style={{ flexShrink: 0 }}>
                <div style={{ width: '80px', height: '80px', borderRadius: '2px', overflow: 'hidden', border: '2px solid rgba(255,87,34,0.3)', position: 'relative' }}>
                  <img src={current?.photo} alt={current?.photoAlt} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ marginTop: '10px' }}>
                  <StarRating count={current?.rating} />
                </div>
              </div>

              {/* Content */}
              <div style={{ flex: 1, minWidth: '240px' }}>
                {/* Quote mark */}
                <div style={{ fontFamily: 'Georgia, serif', fontSize: '64px', lineHeight: 0.8, color: 'rgba(255,87,34,0.2)', marginBottom: '16px', userSelect: 'none' }}>&ldquo;</div>
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', fontWeight: 500, color: 'var(--color-foreground)', lineHeight: 1.8, marginBottom: '24px' }}>{current?.quote}</p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                  <div>
                    <div style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 600, color: 'var(--color-foreground)' }}>{current?.name}</div>
                    <div style={{ fontFamily: 'var(--font-caption)', fontSize: '14px', fontWeight: 400, color: 'var(--color-muted-foreground)', marginTop: '2px' }}>{current?.title}</div>
                  </div>
                  <div style={{ background: 'rgba(255,87,34,0.1)', border: '1px solid rgba(255,87,34,0.25)', borderRadius: '2px', padding: '8px 16px' }}>
                    <div style={{ fontFamily: 'var(--font-caption)', fontSize: '10px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-muted-foreground)', marginBottom: '2px' }}>Sparer</div>
                    <div style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 700, color: '#FF5722' }}>{current?.savings}</div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
      {/* Navigation thumbnails */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px' }}>
        {testimonials?.map((t, i) =>
        <motion.button
          key={t?.id}
          onClick={() => setActive(i)}
          whileHover={{ y: -2 }}
          transition={{ duration: 0.2 }}
          style={{
            background: i === active ? 'rgba(255,87,34,0.08)' : 'rgba(255,255,255,0.02)',
            border: i === active ? '1px solid rgba(255,87,34,0.35)' : '1px solid rgba(224,228,232,0.06)',
            borderRadius: '2px',
            padding: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            cursor: 'pointer',
            textAlign: 'left',
            transition: 'background 0.2s, border-color 0.2s'
          }}>
          
            <img src={t?.photo} alt={t?.photoAlt} style={{ width: '40px', height: '40px', borderRadius: '2px', objectFit: 'cover', flexShrink: 0, border: i === active ? '2px solid #FF5722' : '2px solid transparent' }} />
            <div>
              <div style={{ fontFamily: 'var(--font-heading)', fontSize: '13px', fontWeight: 600, color: i === active ? '#FF5722' : 'var(--color-foreground)' }}>{t?.name}</div>
              <div style={{ fontFamily: 'var(--font-caption)', fontSize: '11px', color: 'var(--color-muted-foreground)', marginTop: '2px' }}>{t?.company}</div>
            </div>
            {i === active &&
          <div style={{ marginLeft: 'auto', width: '6px', height: '6px', background: '#FF5722', borderRadius: '1px', flexShrink: 0 }} />
          }
          </motion.button>
        )}
      </div>
    </section>);

};

export default TestimonialsSection;